<template> 
<div>
    <Row type="flex" justify="start" align="middle" :gutter="16" > 
        <Col :span="formSpan">
            <FormBox ref="form" :config="form"  @input="formChanged"/>
        </Col>
        <Col v-if='operflag' :span="btnSpan">
            <Button   type='default' icon="ios-remove"  @click="doDel"></Button>
        </Col>
    </Row>
</div>
</template>
<script>
    export default {
        name: 'billconditionbox',
        data () {
            return {
                form:{
                    lineNum:12,
                    labelWidth:10,
                    showLabel:false,
                    items:[{
                        name:'field',
                        type:'ComboBox',
                        codeWithName:false,
                        valueChanged:this.fieldChanged,
                        colNum:4,
                       // size:'small',
                        isFull:true
                    },{
                        name:'oper',
                        type:'ComboBox',
                        codeWithName:false,
                        clearable:false,
                        //size:'small',
                        colNum:3,
                        data:[{
                            name: '等于',
                            code: '=='
                        }],
                        defaultValue:'==',
                        isFull:true
                    },{
                        name:'value',
                        type:'TextBox',
                        //size:'small',
                        readOnly:true,
                        colNum:5,
                        isFull:true
                    }]
                },
                dataType:{},
                formSpan:22,
                btnSpan:2
            };
        },
        created () {
            this.init();
        },
        props:{
            config: {
                type: Object,
                default () {
                    return {};
                }
            },
            operflag:{
                type:Boolean,
                default:true
            },
            valueData: {
                type: Object,
                default () {
                    return {};
                }
            },
            curIndex:{
                type:String,
                default:null
            }
        } ,
        mounted () {  
            this.$nextTick(() => {
                if (this.valueData.field){
                    this.fieldChanged({value:this.valueData.field});
                } 
                this.$nextTick(() => {
                    let obj = Object.assign({}, {oper:'=='}, this.valueData);
                    this.$refs.form.setData(obj);
                })
                this.$refs.form.setFormReadOnly(false);
            });
        },
        methods:{
            formChanged(){
                let obj = {};
                obj.index = this.curIndex;
                obj.form  = this.$refs.form.getData();
                this.$emit('input', obj);   
            },
            init() {
                if (this.operflag) {
                    this.formSpan = 22;
                    this.btnSpan = 2;
                } else {
                    this.formSpan = 24;
                    this.btnSpan = 0;
                }
                this.initField();
            },
            initField () {
                let fieldData = [];
                if (this.config.items && this.config.items.length > 0) {
                    this.config.items.forEach(el => {
                        if (el.name && el.label) {
                            fieldData.push({code:el.name,name:el.label});
                            this.dataType[el.name] = Object.assign({},el, {name:'value'});
                            this.dataType[el.name].operData = this.getOperData(el);
                        }
                    });
                }
                this.form.items[0].data = fieldData;

            },
            getOperData(el) {
                let tempData = [];
                tempData.push({
                    name: '等于',
                    code: '=='
                });
                if (el.type === 'DateBox' || el.type === 'NumberBox') {
                    tempData.push({
                        name: '大于',
                        code: '>'
                    });
                    tempData.push({
                        name: '大于等于',
                        code: '>='
                    });
                    tempData.push({
                        name: '小于等于',
                        code: '<='
                    });
                    tempData.push({
                        name: '小于',
                        code: '<'
                    });
                    tempData.push({
                        name: '不等于',
                        code: '<>'
                    });
                } 
                if (el.type === 'TextBox') {
                    tempData.push({
                        name: '不等于',
                        code: '<>'
                    });
                    tempData.push({
                        name: '包含',
                        code: 'LIKE'
                    });
                } 
                if (el.setOperData) {
                    tempData =  el.setOperData(el,tempData);
                }
                return tempData; 
            },
            fieldChanged(e) {
                let self = this;
                let operValue = '==';
                let obj = [];
                let oper = {};
                oper.name = 'oper';
                if (e.value) {
                    let config = Object.assign({},this.dataType[e.value]);
                    oper.data = this.$Method.copy(config.operData);
                    oper.readOnly = false;
                    obj.push(oper);
                    config.name ='value'; 
                    config.label = '';
                    config.readOnly = false;
                    config.visible = true;
                    config.valueChanged = '';
                    obj.push(config);
                    if (e.value.indexOf('name') !== -1) {
                        operValue = 'LIKE';
                    }
                    if (config.operDefaultValue) {
                        operValue = config.operDefaultValue;
                    }
                } else {
                    oper.data = [{
                        name: '等于',
                        code: '=='
                    }];
                    oper.readOnly = true;
                    obj.push(oper);
                    let valueConfig = {
                        name:'value',
                        type:'TextBox',
                        readOnly:true,
                        isFull:true
                    };
                    obj.push(valueConfig);
                }
                self.$refs.form.updateItemsConfig(obj);
                self.$nextTick(() => {
                    self.$refs.form.setValue('oper',operValue); 
                    self.$refs.form.setValue('value',''); 
                });
                return true;
            },
            doAdd (){
                let obj = {};
                obj.name = 'doAdd';
                this.$emit('doAction', obj);
            },
            doDel (){
                let obj = {};
                obj.name = 'doDel';
                obj.index = this.curIndex;
                this.$emit('doAction', obj);
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/layouttemplate/billconditionbox.vue